import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../../shared/services/auth.service';
import { MenuitemComponent } from '../menuitem/menuitem.component';

@Component({
    selector: 'app-menu',
    imports: [MenuitemComponent, RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent {
    model: MenuItem[] = [];
    private authService = inject(AuthService);

    rolUser = this.authService.getUserRole();

    ngOnInit() {
        this.model = [
            {
                label: 'Inicio',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-gauge',
                        routerLink: ['/dd/cp']
                    }
                ]
            },
            {
                label: 'E-COMMERCE',
                items: [
                    {
                        label: 'Pedidos',
                        icon: 'pi pi-fw pi-gift',
                        visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'delivery_person' || this.rolUser === 'manager' || this.rolUser === 'admin',
                        items: [
                            {
                                label: 'Picking de Ordenes',
                                icon: 'pi pi-fw pi-chart-line',
                                visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'delivery_person' || this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/orders/orders']
                            },
                            // {
                            //     label: 'Romaneo de Ordenes',
                            //     icon: 'pi pi-fw pi-database',
                            //     visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'delivery_person' || this.rolUser === 'manager' || this.rolUser === 'admin',
                            //     routerLink: ['/dd/cp/orders/picking-orders']
                            // },
                            {
                                label: 'Ordenes',
                                icon: 'pi pi-fw pi-database',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/orders']
                            },
                            {
                                label: 'Verificación Pagos',
                                icon: 'pi pi-fw pi-money-bill',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/orders/payments']
                            },
                            {
                                label: 'Facturas',
                                icon: 'pi pi-fw pi-database',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/orders/invoice']
                            }
                        ]
                    },
                    // Oculto por el momento
                    // {
                    //     label: 'Favoritos',
                    //     icon: 'pi pi-fw pi-heart',
                    //     visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                    //     routerLink: ['/dd/cp/favorites']
                    // },
                    {
                        label: 'E-Commerce',
                        icon: 'pi pi-fw pi-cart-plus',
                        visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                        routerLink: ['/dd/cp/ecommerce']
                    }
                ]
            },
            {
                label: 'ADMINISTRACIÓN',
                items: [
                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-chart-bar',
                        // Con los demás reportes ocultos, solo queda "Entrada vs Salida" (manager/admin)
                        visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                        // visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'delivery_person' || this.rolUser === 'manager' || this.rolUser === 'admin',
                        items: [
                            {
                                label: 'Entrada vs Salida',
                                icon: 'pi pi-fw pi-chart-line',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/report/movement']
                            }
                            // Ocultos por el momento
                            // {
                            //     label: 'Inventario General',
                            //     icon: 'pi pi-fw pi-database',
                            //     visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'manager' || this.rolUser === 'admin',
                            //     routerLink: ['/dd/cp/report/general']
                            // },
                            // {
                            //     label: 'Inventario por Depósito',
                            //     icon: 'pi pi-fw pi-database',
                            //     visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'manager' || this.rolUser === 'admin',
                            //     routerLink: ['/dd/cp/report/inventory-branch']
                            // },
                            // {
                            //     label: 'Delivery Tracking',
                            //     icon: 'pi pi-fw pi-truck',
                            //     visible: this.rolUser === 'warehouse_operator' || this.rolUser === 'delivery_person' || this.rolUser === 'manager' || this.rolUser === 'admin',
                            //     routerLink: ['/dd/cp/report/delivery-tracking']
                            // }
                        ]
                    },
                    {
                        label: 'Configuración',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                        items: [
                            {
                                label: 'Productos',
                                icon: 'pi pi-fw pi-tags',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/products']
                            },
                            {
                                label: 'Categorias',
                                icon: 'pi pi-fw pi-list-check',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/categories']
                            },
                            {
                                label: 'Depósitos y Stock',
                                icon: 'pi pi-fw pi-map-marker',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/warehause-stock']
                            },
                            {
                                label: 'Sucusales',
                                icon: 'pi pi-fw pi-shop',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/branch']
                            },
                            {
                                label: 'Timbrados',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/timbrado']
                            },
                            {
                                label: 'Roles y Usuarios',
                                icon: 'pi pi-fw pi-id-card',
                                visible: this.rolUser === 'manager' || this.rolUser === 'admin',
                                routerLink: ['/dd/cp/settings/user-rol']
                            }
                        ]
                    }
                ]
            }
        ];
    }
}
